import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage"; 
import BlogPage from "./pages/BlogPage";  // Blog Page Route
import BlogDetailPage from "./pages/BlogDetailPage";  // Product Detail Route
import AboutPage from "./pages/AboutPage"; 
import ShopPage from "./pages/ShopPage"; 
import ContactPage from "./pages/ContactPage"; 

const App = () => (
  <Router>
    <Navbar /> {/* Navbar appears on all pages */}
    <Routes>
      {/* Define Routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/shop" element={<ShopPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/blog" element={<BlogPage />} />  {/* Blog Page Route */}
      <Route path="/blog/:id" element={<BlogDetailPage />} />  {/* Blog Detail Page Route */}
    </Routes>
    <Footer /> {/* Footer appears on all pages */}
  </Router>
);

export default App;

